import { apiClient } from "./apiClient";

export interface ExploreCategoryItem {
  id: string;
  name: string;
  slug: string;
  iconType: string;
  iconUrl?: string | null;
  count: number;
  businessCount?: number;
  offerCount?: number;
  subcategories?: string[];
}

export const fallbackExploreCategories: ExploreCategoryItem[] = [];

export async function fetchExploreCategories(): Promise<ExploreCategoryItem[]> {
  try {
    const res = await apiClient.get<any>(`/loyalty/public/categories`);

    if (res.success && Array.isArray(res.data) && res.data.length > 0) {
      const items: ExploreCategoryItem[] = res.data.map((cat: any) => ({
        id: cat.id || cat._id || cat.slug,
        name: cat.name,
        slug: cat.slug || cat.name.toLowerCase().replace(/[^a-z0-9]+/g, "-"),
        iconType: cat.iconType || "store",
        iconUrl: cat.iconUrl || null,
        count: typeof cat.offerCount === "number" ? cat.offerCount : typeof cat.businessCount === "number" ? cat.businessCount : 0,
        businessCount: typeof cat.businessCount === "number" ? cat.businessCount : 0,
        offerCount: typeof cat.offerCount === "number" ? cat.offerCount : 0,
        subcategories: Array.isArray(cat.subcategories) ? cat.subcategories : [],
      }));

      // Prepend "All deals"
      const totalDeals = items.reduce((acc, c) => acc + (c.offerCount || 0), 0);
      return [
        { id: "all", name: "All deals", slug: "all", iconType: "all", count: totalDeals, offerCount: totalDeals },
        ...items,
      ];
    }
    return [];
  } catch (error) {
    console.warn("fetchExploreCategories failed:", error);
    return [];
  }
}
